import { render, staticRenderFns } from "./Nursing.vue?vue&type=template&id=2f412bb8&"
import script from "./Nursing.vue?vue&type=script&lang=js&"
export * from "./Nursing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports